export const containsKeywords = (keywords: ReadonlyArray<string>, text: string) => {
  const pattern = new RegExp(keywords.join('|').replace('$', '\\$'), 'i')
  return Boolean(text.match(pattern))
}
